import React from 'react';
import LoginContainer from '../container/LoginContainer';
import RegisterForm from '../component/auth/Register';

const RegisterView = (params) => (
    <LoginContainer >
        <RegisterForm />
    </LoginContainer>
)

export default RegisterView;